module.exports = __webpack_public_path__ + "static/simple_agenda-6af01767f5a4efadb9ec34477ce804fd.png";